import React from 'react';
import PropTypes from 'prop-types';
import { Card, Badge } from '@opendate-app/setlist';

export default function MembersDonorsCard({ membersDonors }) {
  if (!membersDonors || !membersDonors.enabled) return null;

  const rows = membersDonors.rows || [];

  return (
    <Card padding="md">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h2 style={{ margin: 0, fontSize: 18 }}>Members & donors</h2>
        <Badge color="purple" size="sm">Module</Badge>
      </div>
      {rows.map((row) => (
        <div
          key={row.label}
          style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, padding: '8px 0' }}
        >
          <span style={{ color: 'var(--sl-text-quaternary, #717680)' }}>{row.label}</span>
          <span style={{ fontWeight: 600 }}>{row.value}</span>
        </div>
      ))}
    </Card>
  );
}

MembersDonorsCard.propTypes = {
  membersDonors: PropTypes.shape({
    enabled: PropTypes.bool,
    rows: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })),
  }),
};
